import { render, staticRenderFns } from "./ParamBanco.vue?vue&type=template&id=00c5a088"
import script from "./ParamBanco.vue?vue&type=script&lang=js"
export * from "./ParamBanco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports